import DOMPurify from 'dompurify';

/**
 * Sanitize du HTML pour usage dans dangerouslySetInnerHTML.
 * Autorise les balises de formatage + tableaux, bloque scripts/événements.
 */
export const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html);
};

/**
 * Sanitize du SVG (GeoGebra).
 * Autorise les balises SVG, bloque scripts/événements.
 */
export const sanitizeSvg = (svg) => {
  if (!svg) return '';
  const clean = DOMPurify.sanitize(svg, { USE_PROFILES: { svg: true, svgFilters: true } });
  // Le SVG RACINE seulement : viewBox ajouté si absent (à partir de width/height), puis width/height retirés pour
  // le rendre responsif. Les SVG imbriqués gardent leur taille : c'est elle qui place chaque image dans son
  // cadre (11/10/2026 : en les retirant aussi, les quatre images de Volcans Q02 débordaient de leurs cadres).
  return clean.replace(/<svg\b[^>]*>/, (racine) => {
    let tag = racine;
    if (!/\sviewBox=/i.test(tag)) {
      const w = parseFloat((tag.match(/\swidth="([^"]*)"/) || [])[1]);
      const h = parseFloat((tag.match(/\sheight="([^"]*)"/) || [])[1]);
      if (w > 0 && h > 0) tag = tag.replace(/<svg/, `<svg viewBox="0 0 ${w} ${h}"`);
    }
    tag = tag.replace(/\s(width|height)="[^"]*"/g, '');
    // width="100%" pour que le SVG remplisse son container
    return tag.replace(/<svg/, '<svg width="100%"');
  });
};
